import { ClientLink } from "@/common/components/client-link/ClientLink";
import { ReadOnlyLinkField } from "@/common/components/read-only-link-field/ReadOnlyLinkField";
import { useTranslation } from "@/translations";

interface Props {
  clientId?: string | null;
  clientName?: string | null;
}

/**
 * Read-only "Kund:in" field for edit dialogs: a clickable {@link ClientLink} when linked to a
 * client, otherwise a disabled text field showing the free-text name.
 */
export function ReadOnlyClientField({ clientId, clientName }: Props) {
  const { t } = useTranslation();

  return (
    <ReadOnlyLinkField
      label={t("common.client")}
      value={clientName ?? ""}
      link={clientId && clientName ? <ClientLink clientId={clientId} name={clientName} variant="body2" /> : undefined}
    />
  );
}
